import React, { useRef, useState } from 'react';

import { useLazyQuery } from '@apollo/react-hooks';
import { useLoggedGeladaLazyQuery } from '@netfront/gelada-identity-library';
import { Client } from '@netfront/gelada-react-shared';
import { addMonths, isValid } from 'date-fns';
import { useParams } from 'react-router-dom';

import ExportPage from './ExportPage';

import { getSignedUrl } from '../../../middleware/AWS/getSignedUrl';
import { EXPORT_MOBILE_APP_ACCESS } from '../../../middleware/Export/exportMobileAppAccess';
import { downloadFileByUrl } from '../../../utils/utils';

const ExportMobileAppAccessPage = () => {
  const { projectId } = useParams();

  const client = useRef(Client()).current;

  const [apiError, setApiError] = useState(undefined);
  const [dateFrom, setDateFrom] = useState(addMonths(new Date(), -1));
  const [dateTo, setDateTo] = useState(new Date());
  const [isFormValid, setIsFormValid] = useState(true);

  const [sendExportMobileAppAccessQuery, { loading: isGeneratingReport }] = useLoggedGeladaLazyQuery({
    query: EXPORT_MOBILE_APP_ACCESS,
    options: {
      client,
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        const { contentType, s3Key } = data.report.exportMobileAppAccess;
        const signedUrl = getSignedUrl(s3Key, contentType);

        downloadFileByUrl(signedUrl);
      },
      onError: (error) => {
        setApiError(error);
      },
    },
  });

  const downloadCSV = () => {
    sendExportMobileAppAccessQuery({
      variables: {
        dateFrom,
        dateTo,
        ianaTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        projectId,
      },
    });
  };

  const handleDateFromChange = (value) => {
    setDateFrom(value);
    setIsFormValid(isValid(dateFrom) && isValid(dateTo));
  };

  const handleDateToChange = (value) => {
    setDateTo(value);
    setIsFormValid(isValid(dateFrom) && isValid(dateTo));
  };

  const options = {
    apiError,
    downloadCSVCallback: downloadCSV,
    filtering: {
      date: {
        dateFrom,
        dateTo,
        handleDateFromChangeCallback: handleDateFromChange,
        handleDateToChangeCallback: handleDateToChange,
      },
    },
    flags: {
      isFormValid,
      preloader: {
        isGeneratingReport,
        isLoadingUserFlowSteps: false,
      },
    },
    infoBannerText: 'This page exports mobile app access based on the selected filters',
  };

  return <ExportPage options={options} />;
};

export default ExportMobileAppAccessPage;
